import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { UserState } from 'types/reducers/user';

import { CLUSTER_HEADER_CATEGORY, TOP_LEVEL_SUBPAGES } from 'utils/constant';

import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';

interface TopLevelClusterHeaderProps {
  subPageName: string;
  subTitle: string;
}

const TopLevelClusterHeader = (data: TopLevelClusterHeaderProps) => {
  const { subPageName, subTitle } = data;

  const getPageTitle = () => {
    return subPageName === TOP_LEVEL_SUBPAGES.JOB ? 'Jobs' : subTitle;
  };

  return (
    <Fragment>
      <div className="job-title-search container d-flex flex-column-reverse flex-lg-row align-items-start">
        <h1 className="career-cluster-header-title career-title-only z-mt-16 z-mt-md-36 z-mb-36">
          {getPageTitle()} near me
        </h1>
        <SearchBar
          className={classNames('z-mt-12 z-mb-20 z-mb-lg-0 z-ml-lg-20', {
            'z-mt-lg-44': subTitle.length > 40,
            'z-mt-lg-40': subTitle.length <= 40,
          })}
          subPageName={subPageName}
          clusterCategory={CLUSTER_HEADER_CATEGORY.CAREER}
        />
      </div>
      <div className="sub-header-container">
        <SubHeader {...data} maxSubheaderItemsCount={7} />
      </div>
    </Fragment>
  );
};

const mapDispatchToProps = {};

export default connect(
  ({ user }: { user: UserState }) => ({
    user,
  }),
  mapDispatchToProps
)(TopLevelClusterHeader);
